import React from 'react';
import Select from 'react-select';
import GridStore from '../panel/store/gridStore';
import { findIndex } from 'underscore';
import clone from 'clone';

class TaxonomySelection extends React.Component {
  constructor(props) {
    super(props);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.handleChange = this.handleChange.bind(this);
    this.taxonomies = [];
  }
  handleChange(val) {
    this.props.onTaxonomySelection(val);
  }
  render() {
    if (this.props.helperData) {
      this.helperData = this.props.helperData ? clone(this.props.helperData) : {};
    }
    const isSearchLayout = findIndex(this.props.allLayout, { type: 'search' });
    if (isSearchLayout !== -1 && this.props.allLayout[isSearchLayout].hasOwnProperty('searchAttr')) {

      this.props.allLayout[isSearchLayout].searchAttr.map((item) => {
        const duplicatedTaxonomyIndex = _.indexOf(this.helperData.taxonomies, item.selectedTaxonomy);
        if (duplicatedTaxonomyIndex !== -1 && this.props.value !== item.selectedTaxonomy) {
          this.helperData.taxonomies = _.without(this.helperData.taxonomies, this.helperData.taxonomies[duplicatedTaxonomyIndex]);
        }
      });
    }
    this.taxonomies = [];
    const panelTypeSearch = this.props.panelType.indexOf('search');
    if ('taxonomies' in this.helperData && panelTypeSearch !== -1) {
      this.helperData.taxonomies.forEach((taxonomy) => {
        this.taxonomies.push({
          'value': taxonomy,
          'label': taxonomy,
        });
      });
    } else {
      this.props.helperData.taxonomies.forEach((taxonomy) => {
        this.taxonomies.push({
          'value': taxonomy,
          'label': taxonomy,
        });
      });
    }
    return (<div className="flex-row">
      {this.taxonomies.length ? <div className="flex-sm-6 flex-md-6 flex-xs-12">
        <Select
          name="form-field-name"
          placeholder="Please select a taxonomy"
          value={this.props.value}
          options={this.taxonomies}
          onChange={this.handleChange}
        />
      </div> : <div> sorry, Please select a post type form content section </div> }
    </div>);
  }
}

TaxonomySelection.propTypes = {
  'panelType': React.PropTypes.string,
  'helperData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'onTaxonomySelection': React.PropTypes.func,
};

export default TaxonomySelection;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/helper/taxonomySelection.js
 **/